import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Must stay a bare <hr> next to its section, or the :has(+:empty) and last: hide rules stop matching
const PDPSectionDivider = t0 => {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("border-0 border-t border-solid border-gray-light7 [&:has(+:empty)]:hidden last:hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <hr className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
PDPSectionDivider.propTypes = {
  className: PropTypes.string
};
export default PDPSectionDivider;